/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react'
import Swal from 'sweetalert2'
import { Modal, Button } from 'react-bootstrap'
import { postRequestOptions, getRequestOptions } from '../helpers/Fetchwrapper'
import validationErrorMsg from '../helpers/ValidationErrorMsg'
import Spinner from 'react-bootstrap/Spinner'
import { Table } from 'react-bootstrap-v5';
import Select from 'react-select'


interface EditSalesOrderItemProps {
	show: boolean;
	handleClose: any;
	salesOrderInfo: any;
	id: number;
}

const EditSalesOrderItem: React.FC<EditSalesOrderItemProps> = ({ show, handleClose, salesOrderInfo, id }) => {

	const numberFormat = (value: number) => {
		return parseFloat(value.toString()).toLocaleString('en-US', {
			style: 'decimal',
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		});
	}

	const [orderRows, setOrderRows] = useState<any[]>([]);
	const [isSubmitDisable, setSubmitDisable] = useState(false);
	const [loading, setLoading] = useState(false);
	const [products, setProducts] = useState<any[]>([]);

	useEffect(() => {
		if (show && salesOrderInfo) {
			const projectId = salesOrderInfo.id_projects || salesOrderInfo.idProjects;
			if (projectId) {
				getProducts(projectId);
			}
			// Reset rows when modal opens to get fresh data
			const freshRows = salesOrderInfo.rows.map((dataRow: any) => {
				// Ensure we capture the product IDs correctly
				const productId = dataRow.id_products || dataRow.idProducts;
				const alternateNameId = dataRow.id_product_group_alternate_names !== null && dataRow.id_product_group_alternate_names !== undefined
					? dataRow.id_product_group_alternate_names
					: (dataRow.idProductGroupAlternateNames !== null && dataRow.idProductGroupAlternateNames !== undefined
						? dataRow.idProductGroupAlternateNames
						: null);
				
				return {
					...dataRow,
					id_products: productId,
					id_product_group_alternate_names: alternateNameId,
					id_sales_order_rows: dataRow.id_sales_order_rows || dataRow.idSalesOrderRows,
					unit_rate: parseFloat(dataRow.unit_rate || 0),
					unit_rate_without_transportation: parseFloat(dataRow.unit_rate_without_transportation || 0),
					transportation_cost: parseFloat(dataRow.transportation_cost || 0),
					original_rate: parseFloat(dataRow.original_rate || 0),
					discount_percent: parseFloat(dataRow.discount_percent || 0),
					quantity: parseFloat(dataRow.quantity || 0),
					originalAmount: parseFloat((parseFloat(dataRow.original_rate || 0) * parseFloat(dataRow.quantity || 0)).toFixed(2)),
					amount: parseFloat((parseFloat(dataRow.unit_rate || 0) * parseFloat(dataRow.quantity || 0)).toFixed(2)),
					productName: (alternateNameId !== null && dataRow.alternate_name) 
						? dataRow.alternate_name.alternate_name 
						: (dataRow.product ? dataRow.product.product_name : ''),
				};
			});
			setOrderRows(freshRows);
		} else if (!show) {
			// Reset when modal closes
			setOrderRows([]);
			setProducts([]);
		}
	}, [show, salesOrderInfo]);

	const getProducts = (projectId: number) => {
		fetch(
			process.env.REACT_APP_API_URL + 'products?idProjects=' + projectId,
			getRequestOptions()
		)
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				let productsList = resp.data.map((item: any) => {
					item.label = item.name_value + ' (' + item.packing + ' ' + item.item_unit_name + ')';
					// Ensure null is converted to string "null" for consistent matching
					// Convert to string to ensure consistent comparison
					const alternateNameId = item.id_product_group_alternate_names === null || item.id_product_group_alternate_names === undefined 
						? 'null' 
						: String(item.id_product_group_alternate_names);
					item.value = String(item.id_products) + '-' + alternateNameId;
					return item
				})
				setProducts(productsList);
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	}

	const handleProductChange = (selectedOption: any, index: number) => {
		const updatedOrderRows = [...orderRows];
		updatedOrderRows[index].id_products = parseInt(selectedOption.value.split('-')[0]);
		updatedOrderRows[index].id_product_group_alternate_names = selectedOption.value.split('-')[1] === "null" ? null : parseInt(selectedOption.value.split('-')[1]);
		updatedOrderRows[index].productName = selectedOption.label;
		// Optionally update rate if product has a default rate
		if (selectedOption.sale_per_unit) {
			updatedOrderRows[index].original_rate = parseFloat(selectedOption.sale_per_unit);
			updatedOrderRows[index].unit_rate = parseFloat(selectedOption.sale_per_unit) + parseFloat(updatedOrderRows[index].transportation_cost || 0);
			updatedOrderRows[index].unit_rate_without_transportation = parseFloat(selectedOption.sale_per_unit);
		}
		// Recalculate amounts
		updatedOrderRows[index].originalAmount = parseFloat((updatedOrderRows[index].quantity * (updatedOrderRows[index].original_rate + updatedOrderRows[index].transportation_cost)).toFixed(2))
		updatedOrderRows[index].amount = parseFloat((updatedOrderRows[index].quantity * (updatedOrderRows[index].original_rate + updatedOrderRows[index].transportation_cost - (updatedOrderRows[index].discount_percent * updatedOrderRows[index].original_rate / 100))).toFixed(2))
		setOrderRows(updatedOrderRows);
	}

	const getSelectedProductValue = (row: any) => {
		// Try multiple possible field names
		const productId = row.id_products || row.idProducts;
		const alternateNameId = row.id_product_group_alternate_names !== null && row.id_product_group_alternate_names !== undefined
			? row.id_product_group_alternate_names
			: (row.idProductGroupAlternateNames !== null && row.idProductGroupAlternateNames !== undefined
				? row.idProductGroupAlternateNames
				: null);
		
		if (productId) {
			// Ensure null is converted to string "null" for consistent matching
			const alternateNameStr = alternateNameId === null || alternateNameId === undefined 
				? 'null' 
				: String(alternateNameId);
			return String(productId) + '-' + alternateNameStr;
		}
		return null;
	}

	const getSelectedProduct = (row: any) => {
		if (!products.length) {
			return null;
		}
		
		const productId = row.id_products || row.idProducts;
		if (!productId) {
			return null;
		}
		
		const value = getSelectedProductValue(row);
		if (!value) {
			return null;
		}
		
		// Find matching product - ensure both values are strings for comparison
		const found = products.find(p => {
			const pValue = String(p.value);
			const rValue = String(value);
			return pValue === rValue;
		});
		
		// If not found, try to find by just product ID (in case alternate name format differs)
		if (!found) {
			const foundById = products.find(p => {
				const pProductId = String(p.value).split('-')[0];
				return pProductId === String(productId);
			});
			return foundById || null;
		}
		
		return found;
	}

	const salesOrderItemSave = async (event: any) => {
		setLoading(true);
		event.preventDefault()
		setSubmitDisable(true);
		const confirm = await Swal.fire({
			title: 'Are you sure?',
			text: "You want to update the Order Items!",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#ec008c',
			cancelButtonText: 'Cancel',
			confirmButtonText: 'Yes, Submit it!',
		})
		if (confirm.value) {

			const requestOptions = postRequestOptions({ rows: orderRows, idSalesOrders: salesOrderInfo.id_sales_orders })
			try {
				let response = await fetch(
					`${process.env.REACT_APP_API_URL}sales-order/update-order-items`,
					requestOptions
				)
				let respData = await response.json()
				if (respData.success === true) {
					const successMsg = respData.successMessage
					Swal.fire({
						icon: 'success',
						title: 'Success',
						text: successMsg,
					})
					handleClose(respData.success)

				} else {
					const errorsMessage = validationErrorMsg(respData.errors).join('<br>')
					Swal.fire({
						icon: 'error',
						title: 'Error',
						html: errorsMessage,
					})
				}
				setSubmitDisable(false);
				setLoading(false);

			} catch (error) {
				setLoading(false);
				console.log(error, 'catch the hoop')
				setSubmitDisable(false);
			}
		}
	}

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
		const updatedOrderRows = [...orderRows];
		updatedOrderRows[index][e.target.name] = (e.target.type === 'number') ? parseFloat(e.target.value) : e.target.value;
		// if (updatedOrderRows[index].discount > parseFloat(updatedOrderRows[index].maxDiscount)) {
		// 	updatedOrderRows[index].discount = 0;
		// }
		// // // updatedOrderRows[index].rate = updatedOrderRows[index].rate - (updatedOrderRows[index].discount * updatedOrderRows[index].rate / 100);
		updatedOrderRows[index].unit_rate = parseFloat(updatedOrderRows[index].original_rate) + parseFloat(updatedOrderRows[index].transportation_cost);
		updatedOrderRows[index].originalAmount = parseFloat((updatedOrderRows[index].quantity * (updatedOrderRows[index].original_rate + updatedOrderRows[index].transportation_cost)).toFixed(2))
		updatedOrderRows[index].amount = parseFloat((updatedOrderRows[index].quantity * (updatedOrderRows[index].original_rate + updatedOrderRows[index].transportation_cost - (updatedOrderRows[index].discount_percent * updatedOrderRows[index].original_rate / 100))).toFixed(2))
		setOrderRows(updatedOrderRows);
	}

	const calculateTotalAmount = () => {
		let totalAmount = 0;

		for (const row of orderRows) {
			totalAmount += (row.originalAmount);
		}

		return totalAmount;
	};

	const calculateTotalDiscountAmount = () => {
		let totalDiscountAmount = 0;

		for (const row of orderRows) {
			totalDiscountAmount += ((row.originalAmount * row.discount_percent) / 100);
		}

		return totalDiscountAmount;
	};

	return (
		<Modal 
			show={show} 
			onHide={() => handleClose(false)} 
			size="xl"
			dialogClassName="modal-xl-custom"
		>
			<style>{`
				.modal-xl-custom {
					max-width: 95vw !important;
					width: 95vw !important;
				}
			`}</style>
			<form onSubmit={salesOrderItemSave}>
				<Modal.Header closeButton>
					<h3>Edit Order Item</h3>
				</Modal.Header>
				<Modal.Body>

					<div className="form-group row">
						{/* Debug: Uncomment to see data structure */}
						{/* <pre>{JSON.stringify({orderRows: orderRows.map(r => ({id_products: r.id_products, id_product_group_alternate_names: r.id_product_group_alternate_names, value: getSelectedProductValue(r)})), products: products.slice(0, 3).map(p => ({value: p.value, label: p.label}))}, null, 2)}</pre> */}
						<Table striped bordered hover size="sm">
							<thead>
								<tr>
									<th>Product</th>
									<th>Delivery Location</th>

									<th>Rate (Per Unit)</th>
									<th>Transportation Cost (Per Unit)</th>
									<th>Effective Rate (Rate + Transportation Cost)</th>
									<th>Order Quantity</th>
									<th>Discount(%)</th>
									<th>Amount</th>
									<th>Amount after Discount</th>
								</tr>
							</thead>
							<tbody>

								{orderRows?.map((item, index) => (
									<>
										<tr key={'item' + index}>
											<td width="30%">
												{/* {JSON.stringify(item)} */}
												<Select
													key={`product-select-${index}-${products.length}-${item.id_products || item.idProducts}`}
													value={getSelectedProduct(item)}
													onChange={(selectedOption) => handleProductChange(selectedOption, index)}
													options={products}
													className='sm'
													menuPosition="fixed"
													placeholder={item.productName}
													isClearable={false}
													styles={{
														control: (provided, state) => ({
															...provided,
															height: '32px',
															minHeight: '32px',
														}),
														container: (provided, state) => ({
															...provided,
															height: '32px',
														}),
													}}
												/>
											</td>
											<td>
												<input type="text" name="delivery_location" value={item.delivery_location} onChange={(event) => handleChange(event, index)} className="form-control form-control-sm" />
											</td>
											<td>
												<input type="number" name="original_rate" onChange={(event) => handleChange(event, index)} value={item.original_rate} className="form-control form-control-sm" />
											</td>
											<td>
												<input type="number" name="transportation_cost" value={item.transportation_cost} onChange={(event) => handleChange(event, index)} className="form-control form-control-sm" />
											</td>
											<td>
												<input type="number" name="effective_rate" readOnly value={item.unit_rate} className="form-control form-control-sm" />
											</td>
											<td>
												<input type="number" name="quantity" value={item.quantity} onChange={(event) => handleChange(event, index)} className="form-control form-control-sm" />
											</td>
											<td>
												<input type="number" name="discount_percent" value={item.discount_percent} onChange={(event) => handleChange(event, index)} className="form-control form-control-sm" />
											</td>
											<td>
												<input type="number" name="originalAmount" readOnly value={item.amount} className="form-control form-control-sm" />
											</td>
											<td>
												<input type="number" name="amount" readOnly value={item.originalAmount} className="form-control form-control-sm" />
											</td>

										</tr>
									</>

								))}
								<tr>
									<td colSpan={8} className='text-end'><b>Total Order Amount:</b></td>
									<td><b>{numberFormat(calculateTotalAmount())}</b></td>
								</tr>
								<tr>
									<td colSpan={8} className='text-end'><b>Total Discount Amount:</b></td>
									<td><b>{numberFormat(calculateTotalDiscountAmount())}</b></td>
								</tr>
								<tr>
									<td colSpan={8} className='text-end'><b>Net Amount:</b></td>
									<td><b>{numberFormat(calculateTotalAmount() - calculateTotalDiscountAmount())}</b></td>
								</tr>


							</tbody>
						</Table>

					</div>

					{/* <pre>{JSON.stringify(orderData, null, 2)}</pre> */}
				</Modal.Body>
				<Modal.Footer>

					<button type="submit" disabled={isSubmitDisable || loading} className="btn btn-sm btn-primary me-2">
						{loading &&
							<Spinner
								as="span"
								animation="grow"
								size="sm"
								role="status"
								aria-hidden="true"
							/>
						}
						<span>  Update</span>
					</button>
					<Button variant='secondary' size="sm" onClick={() => handleClose(false)}>
						Close
					</Button>
				</Modal.Footer>
			</form>
		</Modal>
	)
}

export default EditSalesOrderItem

